import { HubConnection } from "@microsoft/signalr";

/**
 * Shared SignalR connection reference.
 * The connection is created by useNotificationHub (in NotificationBell/Header)
 * and can be accessed by other hooks (e.g. useDataRefresh) via this module.
 */
let sharedConnection: HubConnection | null = null;

export const setSharedConnection = (connection: HubConnection | null) => {
  sharedConnection = connection;
};

export const getSharedConnection = (): HubConnection | null => {
  return sharedConnection;
};
